import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="min-h-screen flex flex-col items-center justify-center text-center px-6">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">Erreur</p>
          <h1 className="mt-2 font-heading font-extrabold text-4xl text-slate-900">
            Une erreur est survenue
          </h1>
          <p className="mt-4 text-slate-600 max-w-md">
            Rechargez la page ou revenez à l'accueil. Si le problème persiste, contactez-nous.
          </p>
          <div className="mt-6 flex gap-3">
            <button
              className="btn-secondary"
              onClick={() => window.location.reload()}
            >
              Recharger
            </button>
            <a href="/" className="btn-primary">
              Retour à l'accueil
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
